<template>
  <card>
    <list
      v-if="$store.state.user.sections['report_trade_ins']"
      :columns="columns"
      :modalCreate="modalCreate"
      :removeLink="removeLink"
      :cardLink="cardLink"
      :isUpdate="true"
      :isAdd="true"
      :itemLink="itemLink"
      :setImport="true"
      :setLink="setLink"
      :staticFilters="staticFilters"
      :openItem="true"
      :fields="fields"
      :filters="filters"
      :params="params"
      :searchDisable="false"
      @change="change"
      @changeFunction="changeFunction"
      v-model="val"
      :exportFields="exportFields"
      :dateFilter="dateFilter"
    />
    <h4 v-else>{{ "no_acccess" | setText("НЕТ ДОСТУПА") }}</h4>
  </card>
</template>
<script>
export default {
  watch: {},
  name: "products",
  methods: {
    changeFunction(val) {},
    change(val) {},
  },
  data() {
    return {
      exportFields: {
        "Номер заказа": "id",
        "Номер сейф-пакета": "code",
        "Статус заявки": "display_status_transfer",
        "Торговая точка": "shop.name",
        Оператор: "user.name",
        "Номер оператора": "user.phone",
        "Название смартфона (клиент)": "name",
        "Производитель смартфона (клиент)": "brand",
        "IMEI смартфона (клиент)": "imei",
        "Стоимость устройства (клиент)": "price",

        "Название смартфона (покупка)": "name_purchase",
        "Производитель смартфона (покупка)": "brand_purchase",
        "IMEI устройства (покупка)": "imei_purchse",
        "Стоимость устройства (покупка)": "price_purchase",

        "Дата оценки": "date",

        "Дата отправки со склада": {
          field: "sent_at",
          callback: (val) => {
            try {
              if (val && typeof val == "string") {
                let date = new Date(val);
                return date.toLocaleString();
              }
              return "Нет даты";
            } catch (error) {
              return val;
            }
          },
        },
        "Дата создания заявки": {
          field: "created_at",
          callback: (val) => {
            try {
              if (val && typeof val == "string") {
                let date = new Date(val);
                return date.toLocaleString();
              }
              return "Нет даты";
            } catch (error) {
              return val;
            }
          },
        },
        PINFL: "PINFL",
        "Номер паспорта": "passport_number",
        Адрес: "passport_address",
        "Кем выдан паспорт": "passport_issued",
        "Дата выдачи паспорта": "passport_issued_at",

        "Штрих-код посылки": "transfer.name",
        "Статус логистики": "transfer.display_status",

        "Срок паспорта": "passport_exp",
        Имя: "first_name",
        Фамилия: "last_name",
        "Номер клиента": {
          field: "phone",
          callback: (value) => {
            return "UZ " + value;
          },
        },
      },

      filters: [
        {
          key: "shop",
          title: "Фильтр по торговым точкам",
          titleKey: "shop_filter",
          field_key: "shop",
          selectKey: "name",
        },
      ],
      staticFilters: [
        {
          title: "Статус",
          key: "status_transfer",
          default: "0",
          items: [
            {
              id: "0",
              title: "Показать все",
            },
            {
              id: "new",
              title: "В процессе",
            },
            {
              id: "process",
              title: "Упакован в сейф-пакет",
            },
            {
              id: "sent",
              title: "Отправлен на склад",
            },
            {
              id: "received",
              title: "Прибыл на склад",
            },
            {
              id: "done",
              title: "Отправлен со склада",
            },
            {
              id: "cancel",
              title: "Отменен",
            },
          ],
        },
      ],
      params: {
        report: 1,
      },
      val: [],
      modalCreate: "role",
      fields: [
        {
          col: "col-12 col-md-6",
          label: "Номер телефона покупателя",
          key: "phone",
          labelKey: "phone",
          type: "mask",
          mask: "+998#########",
          default: "+998",
        },
        {
          col: "col-12 col-md-6",
          label: "Имя",
          key: "first_name",
          type: "field",
        },
        {
          col: "col-12 col-md-6",
          label: "Фамилия",
          key: "last_name",
          type: "field",
        },
        {
          col: "col-12 col-md-6",
          label: "Отчество",
          key: "family_name",
          type: "field",
        },
        {
          col: "col-12 col-md-6",
          label: "Фото передней стороны устройства (хорошее качество)",
          key: "photo_device_front",
          type: "img",
        },
        {
          col: "col-12 col-md-6",
          label: "Фото задней стороны устройства (хорошее качество)",
          key: "photo_device_back",
          type: "img",
        },
        {
          col: "col-12 col-md-6",
          label: "Фото боковой стороны устройства (хорошее качество)",
          key: "photo_device_side",
          type: "img",
        },
      ],
      dateFilter: [
        {
          key: "from_at",
          titleKey: "from_at",
          title: "Начало даты",
        },
        {
          key: "till_at",
          titleKey: "till_at",
          title: "Конец даты",
        },
      ],
      /** APIs */
      removeLink: "",
      cardLink: "item_trade_in_info",
      itemLink: "trade_ins",
      setLink: "trade_ins",
      columns: [
        {
          detail: true,
        },
        {
          key: "id",
          title: "ID",
        },
        {
          key: "code",
          title: "Код сейф-пакета",
        },

        {
          key: "photo_document_sign",
          title: "Договор",
          checkbox: false,
          control: false,
          link: true,
          disableLink: true,
          align: "left",
          timer: false,
          detail: false,
        },
        {
          key: "shop",
          object: "name",
          title: "Торговая точка",
          disableLink: true,
          full: true,
        },

        {
          key: "first_name",
          title: "Имя",
          full: true,
        },
        {
          key: "last_name",
          title: "Фамилия",
          full: true,
        },
        {
          key: "display_status_transfer",
          title: "Статус",
          full: true,
        },

        {
          key: "transfer",
          object: "name",
          title: "Штрих-код посылки",
          disableLink: true,
          full: true,
        },
        {
          key: "transfer",
          object: "display_status",
          title: "Статус логистики",
          disableLink: true,
          full: true,
        },
        {
          key: "client",
          object: "phone",
          title: "Номер телефона",
          full: true,
          disableLink: true,
        },
        {
          key: "user",
          object: "name",
          title: "Оператор",
          disableLink: true,
          full: true,
        },
        {
          key: "user",
          object: "phone",
          title: "Номер оператора",
          disableLink: true,
          full: true,
        },
        {
          key: "name",
          title: "Название смартфона",
          full: true,
        },
        {
          key: "imei",
          title: "IMEI",
          full: true,
        },
        {
          key: "price",
          title: "Оценка",
          price: true,
          full: true,
        },
        {
          key: "name_purchase",
          title: "Название смартфона (новое устройство)",
          full: true,
        },
        {
          key: "imei_purchse",
          title: "IMEI (новое устройство)",
          full: true,
        },
        {
          key: "price_purchase",
          title: "Цена (новое устройство)",
          price: true,
          full: true,
        },
        {
          key: "created_at",
          title: "Дата создания",
          dateTimeFormat: true,
          full: true,
        },
        {
          key: "sent_at",
          title: "Дата отправки со склада",
          dateTimeFormat: true,
          full: true,
        },
      ],
    };
  },
};
</script>